import { useNavigate, useParams, useOutletContext } from 'react-router-dom';
import React from 'react';

export function withRouter(Component) {
    return function WrappedComponent(props) {
        const navigate = useNavigate();
        const params = useParams();
        const context = useOutletContext();
        return <Component {...props} navigate={navigate} params={params} outletContext={context} />;
    };
}
